import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import posthog from 'posthog-js'

import { unsetUser } from '@/app/slices/appSlice'
import { unsetContactId } from '@/app/slices/contactsSlice'
import { unsetCustomerId } from '@/app/slices/customerSlice'
import { unsetGuestUser } from '@/app/slices/guestUserSlice'
import AppToolbar from '@/common/components/AppBar/AppToolbar'

const Logout = () => {
    const dispatch = useDispatch()
    const { logout } = useKindeAuth()

    const handleLogout = async () => {
        // QM-3562: reset the PostHog person before the Kinde SDK redirects, so the next user on
        // a shared browser doesn't inherit this user's identity and flag evaluations. Ordering
        // matters — logout() navigates away, so a reset after the await may never run.
        posthog.reset()
        await logout()
        dispatch(unsetCustomerId())
        dispatch(unsetContactId())
        dispatch(unsetUser())
        dispatch(unsetGuestUser())
    }

    useEffect(() => {
        handleLogout()
    }, [])

    return <AppToolbar />
}

export default Logout
